import { useHistory } from "react-router-dom";

/**
 * Deep-link chip rendered inside an assistant message ("Bekijk op
 * Effecten-pagina →"). Navigation is always user-initiated (one click) — the
 * orchestrator never auto-navigates. The `to` URL is built server-side from the
 * route manifest and may carry a `?focus=<ID>` for the arrival highlight.
 *
 * @param {object} props
 * @param {string} props.label - Chip text.
 * @param {string} props.to - In-app path to navigate to (e.g. "/acme/effects?focus=eff-1").
 */
const DeepLinkChip = ({ label, to }) => {
  const history = useHistory();
  return (
    <button
      type="button"
      className="decca-chip"
      data-to={to}
      onClick={() => history.push(to)}
    >
      <span className="decca-chip-label">{label}</span>
      <span className="decca-chip-arrow" aria-hidden="true">→</span>
    </button>
  );
};

export default DeepLinkChip;
